<script setup lang="ts">
import { useGoogleAd } from '~/composables/useGoogleAd'

interface Props {
  id: string
  unit: string
  sizeMapping: googletag.SizeMappingArray
}
const props = defineProps<Props>()

useGoogleAd(props.id, props.unit, props.sizeMapping)
</script>

<template>
  <div
    :id
    class="ad-google"
  />
</template>
